import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import ModalComponent from '../../../components/common-components/modal/ModalComponent';
import Button from '../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../components/common-components/button/Constants';
import RadioButton from '../../../components/common-components/radioButton/RadioButton';
import Input from '../../../components/common-components/input/Input';
import { componentKey, setABHASuggestionsOpen, setIsVerified } from '../../../pages/Patients/AddPatient/AddPatientSlice';
import { useDispatch, useSelector } from 'react-redux';
import { abhaAddressSuggetions, abhaAddressUpdate } from '../../../pages/Patients/AddPatient/AddPatientSaga';
import Label from '../../../components/common-components/label/Label';

const ChooseAbhaAddressModal = ({ open, close }) => {
  const { createPatientFromAadhaar,transactionIdAndAadhaar, abhaSuggestedAddress } = useSelector((state) => state[componentKey]);
  const dispatch = useDispatch();
  const [showErrorText, setShowErrorText] = useState({ show: false });

  const existingAbhaAddress = createPatientFromAadhaar?.patient?.abhaAddress || '';

  const [selectedOption, setSelectedOption] = useState(existingAbhaAddress);
  const [newAbhaAddress, setNewAbhaAddress] = useState('');

  const handleUpdateABHAAddress = async( abhaAddress) => {
          try{
              const payload = {
                  txnId: transactionIdAndAadhaar?.transactionId || '',
                  abhaAddress: abhaAddress
  
              }
              await dispatch(abhaAddressUpdate({abhaAddressUpdateData:payload}))
  
          } catch (error){
              console.log("Error in suggested address", error)
          }
      }

  const validate = (values) => {
    const errors = {};
    if (!values.abhaAddress) {
        errors.abhaAddress = "ABHA Address is required.";
    } else if (!values.abhaAddress.endsWith("@abdm")) {
        errors.abhaAddress = "ABHA Address must end with '@abdm'.";
    } else {
        const abhaPrefix = values.abhaAddress.slice(0, -4);

        if (abhaPrefix.length < 8) {
            errors.abhaAddress = "ABHA Address must be at least 8 characters excluding '@abdm'.";
        } else if (abhaPrefix.length > 18) {
            errors.abhaAddress = "ABHA Address must not exceed 18 characters excluding '@abdm'.";
        } else {
            
            const dotCount = (abhaPrefix.match(/\./g) || []).length;
            const underscoreCount = (abhaPrefix.match(/_/g) || []).length;

            if (dotCount > 1) {
                errors.abhaAddress = "ABHA Address can have at most 1 dot (.).";
            } else if (underscoreCount > 1) {
                errors.abhaAddress = "ABHA Address can have at most 1 underscore (_).";
            }

            const abhaRegex = /^[a-zA-Z0-9._]+$/;
            if (!abhaRegex.test(abhaPrefix)) {
                errors.abhaAddress =
                    "ABHA Address can only contain alphanumeric characters, dots (.), and underscores (_).";
            }

            if (/^[._]|[._]$/.test(abhaPrefix)) {
                errors.abhaAddress =
                    "ABHA Address cannot start or end with a dot (.) or underscore (_).";
            }
        }
    }

    return errors;
};

  const handleFormSubmit = () => {
     if(selectedOption === 'create'){
        const errors = validate({abhaAddress:`${newAbhaAddress}@abdm`})
        if(Object.keys(errors).length>0){
            setShowErrorText({
                show: true,
                message: errors.abhaAddress
            });
            console.log('error');
        }else{
            setShowErrorText({ show: false });
            handleUpdateABHAAddress(newAbhaAddress)
            dispatch(setABHASuggestionsOpen(false))
        }
     }else{
        dispatch(setABHASuggestionsOpen(false))
        dispatch(setIsVerified(true))
        close()
     }
    
  };
  


  useEffect(() => {
    if (transactionIdAndAadhaar?.transactionId) {
      const payload = {
        txnId: transactionIdAndAadhaar.transactionId,
      };
      dispatch(abhaAddressSuggetions({ abhaAddressSuggetionData: payload }));
    }
  }, [dispatch, transactionIdAndAadhaar]);

  const isContinueDisabled =!selectedOption || (selectedOption === 'create' && newAbhaAddress.trim() === '');

  return (
    <Formik initialValues={{}} onSubmit={handleFormSubmit}>
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <ModalComponent
            open={open}
            close={close}
            title="Create ABHA Address"
            footerButton={
            <div className={`${showErrorText?.show ? "w-full flex items-center justify-between" : ""}`}>
                {showErrorText?.show && 
                <Label asteriskPosition="start" color="red-500" fontSize="sm">* {showErrorText?.message}</Label>}
              <Button
                type="submit"
                variant={BUTTON_VARIANTS.CONTAINED}
                disabled={isContinueDisabled}
              >
                Continue
              </Button>
              </div>
            }
            customClasses="w-[800px]"
          >
            <div className="flex flex-col gap-2">
              <RadioButton
               label={
                <>
                  Use <span className='font-bold'>{existingAbhaAddress}</span>
                </>
              }
                name="abhaAddressOption"
                value={existingAbhaAddress}
                checked={selectedOption === existingAbhaAddress}
                onChangeCb={() => {
                  setShowErrorText(null);
                  setSelectedOption(existingAbhaAddress);
                  setNewAbhaAddress('');
                }}
              />
              <RadioButton
                label="Create new"
                name="abhaAddressOption"
                value="create"
                checked={selectedOption === 'create'}
                onChangeCb={() => {setShowErrorText(null); setSelectedOption('create')}}
              />
            </div>

            {selectedOption === 'create' && (
              <div className="mt-1 relative">
                <Input
                  label="New ABHA Address"
                  type="text"
                  placeholder="Enter new ABHA address"
                  name="newAbhaAddress"
                  value={newAbhaAddress}
                  onChangeCb={(e) => {setShowErrorText(null); setNewAbhaAddress(e.target.value)}}
                />
                <p className="absolute top-6 right-4 p-2">@abdm</p>
              </div>
            )}

            {selectedOption === 'create' &&
              abhaSuggestedAddress?.abhaAddressList?.length > 0 && (
                <ul className="mt-2 flex gap-2">
                  {abhaSuggestedAddress.abhaAddressList.slice(0, 3).map((address, index) => (
                    <li
                      key={index}
                      className="cursor-pointer p-2 rounded border border-met-primary hover:bg-met-primary hover:text-white"
                      onClick={() => setNewAbhaAddress(address)}
                    >
                      {address}@abdm
                    </li>
                  ))}
                </ul>
              )}
          </ModalComponent>
        </Form>
      )}
    </Formik>
  );
};

export default ChooseAbhaAddressModal;
